const mimetype = {
    image: "image/*,image/jpeg,image/png,image/gif,image/bmp,image/x-icon,image/heic,.heic,.heif;capture=camera",
    audio: "audio/*,audio/mpeg,audio/mp3,audio/mp4,audio/ogg,audio/wav,audio/webm,audio/flac;capture=camera",
    video: "video/*,video/mp4,video/quicktime,video/x-msvideo,video/x-ms-wmv,video/x-flv,video/x-matroska,video/webm,video/3gpp,video/3gpp2,video/x-m4v,video/MP2T,.hevc;capture=camera",
    any: "*/*"
}

export default mimetype